module.exports = "<div class=\"alert alert-warning alert-absolute\"> <a href=# class=close aria-label=close title=close>×</a> <strong>This visualization works best on a larger screen.</strong><br> For the best experience, we recommend a screen size of at least 1024 x 768 px. </div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/supportWarning/sizeWarning.html
// module id = 31
// module chunks = 0